<template>
	<div>
		<v-layout row wrap
			justify-end
			align-center
			class="header-booking-data">
			<v-flex xs2 xl-2 lg2 text-xs-right>
				<v-select
					class="filter-select"
					v-bind:items="subsidiaries"
					item-text="name"
					item-value="id"
					v-model="subsidiary"
					hide-details
					single-line
					@input="loadData"
					bottom>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex xs6 pl-0 lg4>
			<v-layout row wrap class="calendar-range">
				<v-flex md12 pa-0 class="border-right">
					<v-menu 
					lazy
					v-model="menuStart"
					transition="scale-transition"
					offset-y
					full-width
					:nudge-left="40"
					class="menu-date-picker"
					max-width="290px">
					<v-text-field
					slot="activator"
					label="Picker in menu"
					v-model="dateStart"
					:disabled="!dateStart"
					prepend-icon="event"
					:append-icon="arrowIconStart"
					single-line
					hide-details
					readonly>
					</v-text-field>
					<v-date-picker
						v-model="dateStart"
						no-title
						scrollable
						@input="disabled"
						>
					</v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
		</v-flex>
			<v-flex xs12 md12 text-xs-right>
				<section class="filters-by-time">
					<v-btn v-for="filter in filters"
						:key="filter.id"
						:class="{'activeBtn': filter.id === value}"
						@click="onDateFilter(filter)"
						:disabled="loading">
						{{filter.label}}
					</v-btn>
				</section>
			</v-flex>
			<v-flex xs12 md2>
				<v-btn
					type="button"
					class="btn-action btn-success white--text"
					@click="customButtons"
				>
					<v-icon>print</v-icon>
					Imprimir Reporte
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap mt-3>
			<v-flex xs12>
				<v-tabs class="checkin-tabs"
					v-model="active">
					<v-tabs-bar class="transparent">
						<v-tabs-slider class="default-skyblue"></v-tabs-slider>
						<v-tabs-item
							v-for="item in items"
							:key="item.id"
							:href="`#${item.name}`">
							{{ item.title }}
						</v-tabs-item>
					</v-tabs-bar>
					<v-tabs-items>
						<v-tabs-content
							v-for="item in items"
							:key="item.id"
							:id="item.name"
							class="pt-5"
						>
							<report-table
								:columns="columns"
								:rows="rows"
								:option-buttons-checkin="actionsButtons"
								@actions="printRow"
								@search-event="searchByColumn"
							/>
						</v-tabs-content>
					</v-tabs-items>
				</v-tabs>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import { addDays, format, subDays } from 'date-fns';
	import FiltersByTime from '@/components/shared/FiltersByTime';
	import helper from '@/shared/helper';
	import ReportTable from '@/clerkinn/reports/sub-component/report-table';

	const helperMethods = helper.methods;

	function disabled() {
		this.date = this.dateStart;
		this.value = 0;
		this.loadData();
	}

	async function printRow({ code }) {
		const baseUrl = process.env.PMS_URL;
		const typeDocumentCode = 'registerCard';
		const name = `TARJETA-DE-EMBARQUE${code}`;
		const responseType = 'blob';
		const cardModel = { details: [{}] };
		const response = await this.$http.post(`${baseUrl}/booking/${code}/report/${typeDocumentCode}`,
		cardModel, { responseType });
		const blob = helperMethods.generateBlob(response.bodyBlob);
		helperMethods.showDownloadDialog(blob, name, 'pdf');
	}

	function created() {
		this.active = 'all';
		this.loadResources();
	}

	function columnSortableEvent() {}

	async function loadResources() {
		const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = subsidiaries.data;
		this.subsidiary = this.subsidiaries[0].id;
	}

	async function loadData() {
		const params = {
			dateStart: this.dateStart,
			dateEnd: helperMethods.formatDate(addDays(this.date, 1), 'YYYY-MM-DD'),
			idSubsidiary: this.subsidiary,
		};
		let results;
		if (this.subsidiary) {
			results = await this.$http.get(`${process.env.PMS_URL}/booking-report/${this.url}?`, { params });

			this.rows = results.data.data.map((element) => {
				const newData = {};
				newData.id = element.id;
				newData.channel = element.channel;
				newData.name = element.customer.data.name;
				newData.lastname = element.customer.data.lastname;
				newData.bookingCode = element.code;
				newData.numReservation = element.numReservation;
				newData.country = element.country;
				newData.isSelected = false;
				newData.roomType = element.bookingRooms.data.roomTypes.data.name;
				newData.codeRoom = element.bookingRooms.data.codeRoom;
				newData.stateName = element.status.name;
				newData.dateStart = format(element.bookingStart, 'YYYY-MM-DD');
				newData.dateStartHours = element.bookingStart.split(' ')[1];
				newData.dateEnd = format(element.bookingEnd, 'YYYY-MM-DD');
				newData.dateEndHours = element.bookingEnd.split(' ')[1];
				newData.total = `$ ${element.total}`;
				newData.color = element.status.colors;
				newData.employee = `${element.employee.data.name} ${element.employee.data.lastname}`;
				newData.paymentStatus = element.paymentStatus.name;
				newData.colorsPayment = element.paymentStatus.colors;
				newData.code = element.code;
				return newData;
			});
		}
	}

	function arrowIconStart() {
		const arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function searchByColumn(search) {
		this.params.search = search;
		this.loadData();
	}

	function active(newValue) {
		const options = {
			all: 'all',
			checkin: 'arrivals',
			checkout: 'leave',
			inhouse: 'in-house',
			noshow: 'no-show',
			void: 'cancel',
		};
		this.url = options[newValue];
		this.loadData();
	}


	function onDateFilter(filter) {
		this.value = filter.id;
		if (this.value === 1) {
			this.dateStart = format(addDays(new Date(), 0), 'YYYY-MM-DD');
			this.date = this.dateStart;
		} else {
			this.dateStart = format(addDays(new Date(), 1), 'YYYY-MM-DD');
			this.date = this.dateStart;
		}
		this.loadData();
	}

	function customButtons({ btn, row }) {
		if (btn && btn.name === 'registration-card') {
			if (this.active === 'checkin') {
				this.printRegistrationCad(row);
			}
		} else {
			const reports = {
				inhouse: 'inHouse',
				checkin: 'arrivals',
				checkout: 'leave',
				all: 'all',
				void: 'cancel',
				noshow: 'no-show',
			};
			this.printReports(reports[this.active]);
		}
	}

	function getStartDate() {
		if (this.value === 1) {
			return helperMethods.formatDate(new Date(), 'YYYY-MM-DD');
		}
		return helperMethods.formatDate(addDays(new Date(), 0), 'YYYY-MM-DD');
	}

	async function printReports(code) {
		const baseUrl = process.env.PMS_URL;
		const name = `TARJETA-DE-Reporte${code}`;
		const responseType = 'blob';
		const cardModel = { details: [{}] };
		const dateStart = `dateStart=${this.dateStart}`;
		const dateEnd = `dateEnd=${format(addDays(this.dateStart, 1), 'YYYY-MM-DD')}`;
		const idSubsidiary = `idSubsidiary=${this.subsidiary}`;
		const response = await this.$http.post(
			`${baseUrl}/report/${code}?${dateStart}&${dateEnd}&${idSubsidiary}`,
			cardModel,
			{ responseType },
		);
		const blob = helperMethods.generateBlob(response.bodyBlob);
		helperMethods.showDownloadDialog(blob, name, 'pdf');
	}

	async function printRegistrationCad(item) {
		const baseUrl = process.env.PMS_URL;
		const typeDocumentCode = 'registerCard';
		const name = `TARJETA-DE-REGISTRO${item.bookingCode}`;
		const responseType = 'blob';
		const cardModel = { details: [{}] };
		const response = await this.$http.post(`${baseUrl}/booking/${item.bookingCode}/report/${typeDocumentCode}`,
			cardModel, { responseType });
		const blob = helperMethods.generateBlob(response.bodyBlob);
		helperMethods.showDownloadDialog(blob, name, 'pdf');
	}

	function customColor({ color }) {
		return `color: ${color}`;
	}

	function actionsButtons() {
		const action = {
			all: this.optionButtonsCheckin,
			checkin: this.optionButtonsCheckin,
		};
		return action[this.active] || [];
	}

	function data() {
		return {
			menuStart: false,
			dateStart: format(subDays(new Date(), 0), 'YYYY-MM-DD'),
			active: '',
			columns: [
				{ id: 1, name: '# Rva', code: 'numReservation', isSortable: { down: false, up: false } },
				{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } },
				{ id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: false, up: false } },
				{ id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } },
				{ id: 5, name: 'Hab.', code: 'roomType', isSortable: { down: false, up: false } },
				{ id: 6, name: 'Estado', code: 'stateName', isSortable: { down: false, up: false } },
				{ id: 7, name: 'Fec. Salida', code: 'date', isSortable: { down: false, up: false } },
				{ id: 8, name: 'Usuario', code: 'employee', isSortable: { down: false, up: false } },
				{ id: 9, name: 'Importe', code: 'total', isSortable: { down: false, up: false } },
			],
			columnsNoShow: [
				{ id: 1, name: '# Rva', code: 'bookingCode', isSortable: { down: false, up: false } },
				{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } },
				{ id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: false, up: false } },
				{ id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } },
				{ id: 4, name: 'Hab.', code: 'roomType', isSortable: { down: false, up: false } },
				{ id: 5, name: 'Estado', code: 'stateName', isSortable: { down: false, up: false } },
				{ id: 6, name: 'Fecha Llegada', code: 'date', isSortable: { down: false, up: false } },
				{ id: 7, name: 'Usuario', code: 'user', isSortable: { down: false, up: false } },
			],
			columnsTotal: [
				{ id: 1, name: '# Rva', code: 'bookingCode', isSortable: { down: false, up: false } },
				{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } },
				{ id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: false, up: false } },
				{ id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } },
				{ id: 4, name: 'Hab.', code: 'roomType', isSortable: { down: false, up: false } },
				{ id: 5, name: 'Estado', code: 'stateName', isSortable: { down: false, up: false } },
				{ id: 6, name: 'Fecha Llegada', code: 'date', isSortable: { down: false, up: false } },
				{ id: 7, name: 'Usuario', code: 'user', isSortable: { down: false, up: false } },
			],
			columnsVoid: [
				{ id: 1, name: '# Rva', code: 'bookingCode', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: true, up: false } },
				{ id: 4, name: 'País', code: 'country', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Hab.', code: 'roomType', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Estado', code: 'stateName', isSortable: { down: true, up: false } },
				{ id: 6, name: 'Fecha Llegada', code: 'date', isSortable: { down: true, up: false } },
				{ id: 7, name: 'Usuario', code: 'user', isSortable: { down: true, up: false } },
			],
			date: format(new Date(), 'YYYY-MM-DD'),
			filters: [
				{
					id: 1, value: 1, label: 'Hoy',
				},
				{
					id: 2, value: 2, label: 'Mañana',
				},
			],
			items: [
				{ id: 1, name: 'all', title: 'Total' },
				{ id: 2, name: 'checkin', title: 'Llegadas' },
				{ id: 3, name: 'inhouse', title: 'Huéspedes In - House' },
				{ id: 4, name: 'checkout', title: 'Salidas' },
				{ id: 5, name: 'void', title: 'Anuladas' },
				{ id: 6, name: 'noshow', title: 'No Show' },
			],
			loading: false,
			noShowData: [],
			optionButtonsCheckin: [
				{
					id: 1,
					icon: 'print',
					name: 'registration-card',
				},
			],
			printInHouse: {
				btn: { name: 'registration-card' },
			},
			rows: [],
			rowSelected: {},
			subsidiaries: [],
			subsidiary: 0,
			totalData: [],
			value: 1,
			voidData: [],
			url: 'arrivals',
		};
	}

	export default {
		name: 'report-bookings',
		components: {
			FiltersByTime,
			ReportTable,
			TableRun,
		},
		computed: {
			arrowIconStart,
			actionsButtons,
		},
		created,
		data,
		methods: {
			printRow,
			disabled,
			searchByColumn,
			columnSortableEvent,
			customButtons,
			customColor,
			getStartDate,
			loadResources,
			loadData,
			onDateFilter,
			printReports,
			printRegistrationCad,
		},
		watch: {
			active,
		},
	};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 52px;
		width: calc(100% - 230px);

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}
	}

	.td-state {
		span.booking-td {
			color: map-get($colors, booking-td);
		}

		span.inhouse-td {
			color: map-get($colors, inhouse);
		}
	}
</style>


// WEBPACK FOOTER //
// Bookings.vue?be2e737c